import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withLogger } from 'modules/shell/hoc/withLogger';
import { withConfig } from 'modules/shell/hoc/withConfig';
import { withStyles } from '@material-ui/core/styles';
import {
  addCloudinaryBarcode,
  clearSendsReceiptBarcode,
  triggerSendStoreReceipt,
} from '../../actions/sendsTakesActions';
import SendsReceiptModal from './SendsReceiptModal';
import styles from './SendsReceiptModal.styles';

const mapStateToProps = ({ cartModule: sendsReceipts }) => {
  const { loading, error, uploadedUrl, emailConfirmed } = sendsReceipts;

  return {
    loading,
    error,
    barcodeUrl: uploadedUrl,
    sentConfirmation: emailConfirmed,
  };
};

const mapDispatchToProps = (dispatch, { config }) =>
  bindActionCreators(
    {
      uploadBarcode: (files, barcode) => addCloudinaryBarcode(config.get('cloudinary'), files, barcode),
      triggerSendStoreReceipt,
      clearSendsReceiptBarcode,
    },
    dispatch,
  );

export default compose(
  withConfig(),
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
  withLogger(),
)(SendsReceiptModal);
